import base from './base.repository';
export default {
    ...base,
    getMails(personId, filters, page = 1){
        const qs = this.querify({...filters, person: personId, page });
        return this.get('mails' + qs);
    },
    getMailTypes(){
        return this.get('vigilance/mail-types');
    },
}


// WEBPACK FOOTER //
// ./src/repositories/mail.repository.js